/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { analyticsCampaignMetaAnalytics } from '../../axios/analyticsCampaignMetaAnalytics'
import type {
	AnalyticsCampaignMetaAnalyticsError,
	AnalyticsCampaignMetaAnalyticsPathParams,
	AnalyticsCampaignMetaAnalyticsResponse,
} from '../../types/AnalyticsCampaignMetaAnalytics'

export const analyticsCampaignMetaAnalyticsQueryKey = (
	campaign: AnalyticsCampaignMetaAnalyticsPathParams['campaign'],
) => [{ url: '/campaigns/:campaign/meta-analytics', params: { campaign } }] as const

export type AnalyticsCampaignMetaAnalyticsQueryKey = ReturnType<typeof analyticsCampaignMetaAnalyticsQueryKey>

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::campaignMetaAnalytics */
export function analyticsCampaignMetaAnalyticsQueryOptions(
	campaign: AnalyticsCampaignMetaAnalyticsPathParams['campaign'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		AnalyticsCampaignMetaAnalyticsResponse,
		AxiosError<AnalyticsCampaignMetaAnalyticsError>,
		AnalyticsCampaignMetaAnalyticsResponse,
		AnalyticsCampaignMetaAnalyticsQueryKey
	>({
		queryKey: analyticsCampaignMetaAnalyticsQueryKey(campaign),
		queryFn: ({ signal }) => analyticsCampaignMetaAnalytics(campaign, { signal, ...config }).then(res => res.data),
		enabled: !!campaign,
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::campaignMetaAnalytics */
export function useAnalyticsCampaignMetaAnalytics<TSelectData = AnalyticsCampaignMetaAnalyticsResponse>(
	campaign: AnalyticsCampaignMetaAnalyticsPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					AnalyticsCampaignMetaAnalyticsResponse,
					AxiosError<AnalyticsCampaignMetaAnalyticsError>,
					TSelectData,
					AnalyticsCampaignMetaAnalyticsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<AnalyticsCampaignMetaAnalyticsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...analyticsCampaignMetaAnalyticsQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/AnalyticsController.php AnalyticsController::campaignMetaAnalytics */
export function useAnalyticsCampaignMetaAnalyticsSuspense<TSelectData = AnalyticsCampaignMetaAnalyticsResponse>(
	campaign: AnalyticsCampaignMetaAnalyticsPathParams['campaign'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					AnalyticsCampaignMetaAnalyticsResponse,
					AxiosError<AnalyticsCampaignMetaAnalyticsError>,
					TSelectData,
					AnalyticsCampaignMetaAnalyticsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<AnalyticsCampaignMetaAnalyticsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...analyticsCampaignMetaAnalyticsQueryOptions(campaign),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
